import { Typography } from '@euler/app/components/typography';
import {
  useAiChatActions,
  useAiChatMessage,
} from '@euler/app/flows/ai-suite/chat/AiChatActions';
import { ChatCard } from '@euler/app/flows/ai-suite/components/ChatCard';
import { aiColors, tint } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingCaseFormat } from '@euler/model/coaching';
import { Split } from 'lucide-react-native';
import { memo, useState } from 'react';
import { Pressable, View } from 'react-native';
import { kFormatNames } from '../copy';

const kChoices: { format: CoachingCaseFormat; hint: string }[] = [
  {
    format: CoachingCaseFormat.Drill,
    hint: '从这一刻开始，几个来回就能练完，练到这一步做好为止。',
  },
  {
    format: CoachingCaseFormat.Full,
    hint: '从接待开始走完整段对话，结束时有完整点评。',
  },
];

/** A single moment: practise it as a short drill, or as a full talk. */
export const DrillOfferCard = memo(({ title }: { title: string }) => {
  const { rpx } = useResponsiveContext();
  const chat = useAiChatActions();
  const { latest } = useAiChatMessage();
  const [chosen, setChosen] = useState<CoachingCaseFormat | null>(null);
  const choose = (format: CoachingCaseFormat) => {
    if (chat.send(kFormatNames[format])) setChosen(format);
  };
  return (
    <ChatCard
      icon={Split}
      color={aiColors.primary}
      title="练这一刻，还是走完整段？"
      subtitle={title}
      tinted
    >
      <View style={{ gap: rpx(8), padding: rpx(14) }}>
        {kChoices.map(choice => {
          const on = chosen === choice.format;
          const enabled = latest && !chosen && !chat.busy;
          return (
            <Pressable
              key={choice.format}
              disabled={!enabled}
              onPress={() => choose(choice.format)}
              accessibilityRole="button"
              style={{
                borderRadius: rpx(10),
                borderWidth: 1,
                borderColor: on ? aiColors.primary : aiColors.border,
                backgroundColor: on
                  ? tint(aiColors.primary, 0.06)
                  : aiColors.card,
                padding: rpx(12),
                opacity: enabled || on ? 1 : 0.6,
              }}
            >
              <Typography.Text size={rpx(14)} bold color={aiColors.foreground}>
                {kFormatNames[choice.format]}
              </Typography.Text>
              <Typography.Text
                size={rpx(12)}
                color={aiColors.mutedForeground}
                lineHeight={rpx(18)}
              >
                {choice.hint}
              </Typography.Text>
            </Pressable>
          );
        })}
      </View>
    </ChatCard>
  );
});
